import { Container, Paper } from '@material-ui/core'
import PageBackground from './components/PageBackground'
import { NavigationWrapperV2 as NavigationWrapper } from '@scoir/messaging'
import { makeStyles } from '@material-ui/core/styles'
import { Redirect, Route, RouteComponentProps } from 'react-router-dom'

import UserAware from 'components/UserAware'

import Messages from './Messages'
import Notifications from './Notifications'

const EXTERNAL_CLASSES = {
    fillViewHeightComp: 'fill-view-height-comp',
    msgctrNavigationWrapperLinks: 'msgctr-navigation-wrapper-links',
    msgctrNavigationWrapperLink: 'msgctr-navigation-wrapper-link',
} as const

const useStyles = makeStyles((theme) => ({
    customMessageCenterHeight: {
        height: '100%',
        [`& .${EXTERNAL_CLASSES.fillViewHeightComp}`]: {
            height: 'calc(100vh - 229px) !important',
            [theme.breakpoints.down('sm')]: {
                height: 'calc(100vh - 253px) !important',
            },
        },
    },
    border: {
        marginBottom: '0px',
    },
    container: {
        display: 'flex',
    },
    paper: {
        height: '100%',
    },
    body: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    routeMessageCenter: {
        [theme.breakpoints.down('xs')]: {
            paddingRight: '0 !important',
            paddingLeft: '0 !important',
        },
        [`& .${EXTERNAL_CLASSES.msgctrNavigationWrapperLinks}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            whiteSpace: 'nowrap',
            overflowY: 'hidden',
            height: '50px',
            [theme.breakpoints.down('xs')]: {
                overflowX: 'scroll',
            },
        },
        [`& .${EXTERNAL_CLASSES.msgctrNavigationWrapperLink}`]: {
            width: '144px',
            height: '48px',
            display: 'inline-flex',
            alignItems: 'center',
            marginRight: 0,
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                padding: '12px !important',
            },
        },
    },
}))


const MessageCenter = ({ match }: RouteComponentProps) => {
    const classes = useStyles()
    const { path } = match
    const links = [
        {
            path: `${path}/messages`,
            label: 'Direct Messages',
        },
        {
            path: `${path}/notifications`,
            label: 'Notifications',
        },
    ]
    return (
        <PageBackground className={classes.container}>
            <Container
                maxWidth={false}
                disableGutters
                className={classes.routeMessageCenter}
            >
                <div className={classes.customMessageCenterHeight}>
                    <Paper
                        variant="outlined"
                        elevation={0}
                        className={classes.paper}
                    >
                        <NavigationWrapper links={links}>
                            <div className={classes.body}>
                                <Route
                                    exact
                                    path={`${path}/messages`}
                                    render={(props) => (
                                        <UserAware
                                            render={(user) => (
                                                <Messages
                                                    userId={user.Id}
                                                    {...props}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                <Route
                                    exact
                                    path={`${path}/notifications`}
                                    component={Notifications}
                                />
                                <Redirect to={links[0].path} />
                            </div>
                        </NavigationWrapper>
                    </Paper>
                </div>
            </Container>
        </PageBackground>
    )
}

export default MessageCenter
